import { useTheme } from '@emotion/react'
import { Container, Section } from 'chaoskit/src/components'
import { text } from 'chaoskit/src/assets/styles/utility'

import { StylesFooter } from '.'

import Link from '~components/Link'

const StaticFooter = () => {
  const theme = useTheme()

  return (
    <Section
      as="footer"
      css={[
        StylesFooter(theme),
        {
          textAlign: 'center',
        },
      ]}
      className="u-contrast"
    >
      <Container>
        <p>
          <strong>&copy; {new Date().getFullYear()} Gremlin Inc.</strong>
          <br />
          All rights reserved.
          <br />
          <Link css={[text.underline]} className="u-link" to="/privacy/">
            Privacy Policy
          </Link>
        </p>
      </Container>
    </Section>
  )
}

export default StaticFooter
